/* import __COLOCATED_TEMPLATE__ from './dialog.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* eslint-disable @typescript-eslint/no-explicit-any */
import Component from '@glimmer/component';
import { getOwner } from '@ember/application';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { inject as service } from '@ember/service';
import { typeOf } from '@ember/utils';
import { Keys } from 'ember-headlessui/utils/keyboard';
import { modifier } from 'ember-modifier';
let DialogComponent = (_class = class DialogComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "dialogStackProvider", _descriptor, this);
    _defineProperty(this, "DEFAULT_TAG_NAME", 'div');
    _defineProperty(this, "guid", `${guidFor(this)}-headlessui-dialog`);
    _defineProperty(this, "$portalRoot", void 0);
    _defineProperty(this, "outsideClickedElement", null);
    _defineProperty(this, "stack", modifier(() => {
      this.dialogStackProvider.push(this);
      return () => {
        this.dialogStackProvider.remove(this);
      };
    }));
    _defineProperty(this, "handleEscapeKey", modifier((_element, [isOpen, onClose]) => {
      let handler = event => {
        if (event.key !== Keys.Escape) return;
        if (!isOpen) return;
        event.preventDefault();
        event.stopPropagation();
        onClose();
      };
      window.addEventListener('keyup', handler);
      return () => {
        window.removeEventListener('keyup', handler);
      };
    }));
    _defineProperty(this, "lockWindowScroll", modifier(() => {
      // Opt-out of some other dialog already locked scrolling
      if (this.dialogStackProvider.dialogIsOpen) {
        return;
      }
      let overflow = this.$portalRoot.style.overflow;
      let paddingRight = this.$portalRoot.style.paddingRight;

      // Setting `overflow: hidden` will suddenly hide the scroll bar on the window, which can cause horizontal
      // layout shifting when the `Dialog` becomes open
      // By applying the width of the scroll bar as padding, we can avoid that layout shift from happening
      let scrollbarWidth = window.innerWidth - this.$portalRoot.clientWidth;
      this.$portalRoot.style.overflow = 'hidden';
      this.$portalRoot.style.paddingRight = `${scrollbarWidth}px`;
      return () => {
        this.$portalRoot.style.overflow = overflow;
        this.$portalRoot.style.paddingRight = paddingRight;
      };
    }));
    const {
      APP: {
        rootElement
      }
    } = getOwner(this) /* typed-ember does not have types for Owner */.resolveRegistration('config:environment');
    this.$portalRoot = rootElement ? document.querySelector(rootElement) : document.body;
    let {
      isOpen: _isOpen,
      onClose: _onClose
    } = this.args;
    if (_isOpen === undefined && _onClose === undefined) {
      throw new Error('You have to provide an `isOpen` and an `onClose` prop to the `Dialog` component.');
    }
    if (_isOpen === undefined) {
      throw new Error('You provided an `onClose` prop to the `Dialog`, but forgot an `isOpen` prop.');
    }
    if (_onClose === undefined) {
      throw new Error('You provided an `isOpen` prop to the `Dialog`, but forgot an `onClose` prop.');
    }
    if (typeOf(_isOpen) !== 'boolean') {
      throw new Error(`You provided an \`isOpen\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${_isOpen}`);
    }
    if (typeOf(_onClose) !== 'function') {
      throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${_onClose}`);
    }
  }
  get tagName() {
    return this.args.as || this.DEFAULT_TAG_NAME;
  }
  get dialogElementSelector() {
    return `#${this.guid}`;
  }
  get overlayGuid() {
    return `${this.guid}-overlay`;
  }
  get titleGuid() {
    return `${this.guid}-title`;
  }
  get descriptionGuid() {
    return `${this.guid}-description`;
  }
  setReturnFocus(trigger) {
    return this.outsideClickedElement ? this.outsideClickedElement : trigger;
  }
  allowOutsideClick(e) {
    let target = e.target;
    if (target && target.tagName !== 'BODY') {
      this.outsideClickedElement = target;
    }
    this.onClose();
    return true;
  }
  onClose() {
    if (this.dialogStackProvider.hasOpenChild(this)) return;
    this.args.onClose();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "dialogStackProvider", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setReturnFocus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setReturnFocus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "allowOutsideClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "allowOutsideClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onClose"), _class.prototype), _class);
export { DialogComponent as default };